import axios from "axios";



export const api = axios.create({
  // baseURL: "http://localhost:5000/api",
  baseURL: "https://studentportal.hafizbrothersestate.com/api",

  headers: {
    "Content-Type": "application/json",
  },
});

// Call this after login/logout to attach/remove token
export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common.Authorization;
  }
};
